import { Breadcrumbs, Link } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const BreadcrumbCardstock = ({ isWarehouse, batchName }) => {
  const { productId = "" } = useParams();
  const { batchId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="text-[12px] text-[#2C3E5D]">
      <Breadcrumbs
        sx={{ color: "#2C3E5D" }}
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" />}
      >
        <Link
          underline="hover"
          color="inherit"
          href="/profile"
          onClick={() => navigate("/profile")}
        >
          Home
        </Link>
        {window.location.pathname.includes("/inventory/card-stock") ? (
          <Link
            underline="hover"
            color="inherit"
            href={`${
              isWarehouse ? "/central-warehouse" : ""
            }/inventory/card-stock`}
            onClick={() =>
              navigate(
                `${
                  isWarehouse ? "/central-warehouse" : ""
                }/inventory/card-stock`
              )
            }
          >
            Kartu Stok
          </Link>
        ) : null}
        {window.location.pathname.includes(
          "/inventory/card-stock/card-stock-detail-new/"
        ) ||
        window.location.pathname.includes(
          "/inventory/card-stock/card-stock-detail-batch/"
        ) ? (
          <Link
            underline="hover"
            color="inherit"
            href={`${
              isWarehouse ? "/central-warehouse" : ""
            }/inventory/card-stock/card-stock-detail-new/${productId}`}
            onClick={() =>
              navigate(
                `${
                  isWarehouse ? "/central-warehouse" : ""
                }/inventory/card-stock/card-stock-detail-new/${productId}`
              )
            }
          >
            Detail Kartu Stok
          </Link>
        ) : null}
        {window.location.pathname.includes(
          "/inventory/card-stock/card-stock-detail-batch/"
        ) ? (
          <Link
            underline="hover"
            color="inherit"
            href={`${
              isWarehouse ? "/central-warehouse" : ""
            }/inventory/card-stock/card-stock-detail-batch/${productId}/${batchId}`}
            onClick={() =>
              navigate(
                `${
                  isWarehouse ? "/central-warehouse" : ""
                }/inventory/card-stock/card-stock-detail-batch/${productId}/${batchId}`
              )
            }
          >
            {batchName}
          </Link>
        ) : null}
      </Breadcrumbs>
    </div>
  );
};

export default BreadcrumbCardstock;
